import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANGUAGES } from '../shared/constants.js';

// Import translation files
import enTranslations from './locales/en/common.json';
import frTranslations from './locales/fr/common.json';
import esTranslations from './locales/es/common.json';
import arTranslations from './locales/ar/common.json';
import heTranslations from './locales/he/common.json';

// Language resources
const resources = {
  en: {
    translation: enTranslations
  },
  fr: {
    translation: frTranslations
  },
  es: {
    translation: esTranslations
  },
  ar: {
    translation: arTranslations
  },
  he: {
    translation: heTranslations
  }
};

// Supported languages - derived from LANGUAGES constant
const supportedLngs = LANGUAGES.map(lang => lang.code);

/**
 * Check if a language code is RTL (Right-to-Left)
 * @param {string} languageCode - Language code (e.g., 'en', 'he', 'ar')
 * @returns {boolean} True if the language is RTL
 */
export function isRTL(languageCode) {
  const language = LANGUAGES.find(lang => lang.code === languageCode);
  return language ? language.isRtl : false;
}

i18n
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language
    supportedLngs: supportedLngs,
    
    // Language detection options: URL ?lang= first (e.g. shared plan links), then localStorage
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    react: {
      useSuspense: false // Disable suspense for better compatibility
    }
  });

// Set document direction based on language
const updateDocumentDirection = (lng) => {
  const isRtlLang = isRTL(lng);
  document.documentElement.dir = isRtlLang ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
};

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  updateDocumentDirection(lng);
  // Save to localStorage
  localStorage.setItem('i18nextLng', lng);
});

// Set initial direction
updateDocumentDirection(i18n.language);

export default i18n;
